import axios from 'axios';
export class TokenVerificationService {
  static async verify(baseUrl, token, opts = {}) {
    return axios.put(
      `${baseUrl}/verify-email`,
      { token },
      {
        headers: {
          'x-api-key': opts.apiKey
        }
      }
    );
  }
}
